export const runtimeEnvironments = {
    LOCAL: {
        siriusCdnBaseUrl: '/cdn',
        siriusHeaderVersion: '',
        siriusNavbarVersion: '',
        siriusQuickNavVersion: '',
        siriusFooterVersion: '',
        cdnBaseUrl: '/cdn',
        customCodeVersion: '',
        assetsLibraryEndpoint: '/tdp-assets-library',
        assetsLibraryVersion: '',
        catalogsEndpoint: '/si-registry/api/v1/catalogs',
        usersEndpoint: '/tdm-users/public/current-user',
        dciAuthBaseUrl: 'https://www-poc.dell.com',
        dciClientId: 'a0bdbcbc-4937-41fe-8f84-c0c841d2e036',
        changeImpersonationUrl: 'https://techdirect-uat2.dell.com/Portal/SupportProcessor.aspx',
        tdpNavBarUrl: '/cdn/si-elements/tdp-navbar-mfe/tdp-navbar-mfe.js',
        hostUrl: 'https://localhost.dell.com'
    },
    STAGING: {
        siriusCdnBaseUrl: '/cdn',
        siriusHeaderVersion: '',
        siriusNavbarVersion: '',
        siriusQuickNavVersion: '',
        siriusFooterVersion: '',
        cdnBaseUrl: '/cdn',
        customCodeEndpoint: '/tdp-tenant-custom-code',
        customCodeVersion: '/latest',
        assetsLibraryEndpoint: '/tdp-assets-library',
        assetsLibraryVersion: '/latest',
        catalogsEndpoint: '/si-registry/api/v1/catalogs',
        usersEndpoint: '/tdm-users/public/current-user',
        dciAuthBaseUrl: 'https://www-poc.dell.com',
        dciClientId: 'b0c50012-875f-4758-8a66-9580458cfabe',
        changeImpersonationUrl: 'https://techdirect-uat.dell.com/Portal/SupportProcessor.aspx',
        tdpNavBarUrl: '/si-elements/tdp-navbar-mfe/tdp-navbar-mfe.js',
        hostUrl: 'https://csm-td-staging.dell.com'
    },
    INT: {
        siriusCdnBaseUrl: '/cdn',
        siriusHeaderVersion: '',
        siriusNavbarVersion: '',
        siriusQuickNavVersion: '',
        siriusFooterVersion: '',
        cdnBaseUrl: '/cdn',
        customCodeEndpoint: '/tdp-tenant-custom-code',
        customCodeVersion: '/latest',
        assetsLibraryEndpoint: '/tdp-assets-library',
        assetsLibraryVersion: '/latest',
        catalogsEndpoint: '/si-registry/api/v1/catalogs',
        usersEndpoint: '/tdm-users/public/current-user',
        dciAuthBaseUrl: 'https://www-poc.dell.com',
        dciClientId: 'a0bdbcbc-4937-41fe-8f84-c0c841d2e036',
        changeImpersonationUrl: 'https://techdirect-uat2.dell.com/Portal/SupportProcessor.aspx',
        tdpNavBarUrl: '/si-elements/tdp-navbar-mfe/tdp-navbar-mfe.js',
        hostUrl: 'https://csm-td-int.dell.com'
    },
    PROD: {
        production: true,
        siriusCdnBaseUrl: '/cdn',
        siriusHeaderVersion: '',
        siriusNavbarVersion: '',
        siriusQuickNavVersion: '',
        siriusFooterVersion: '',
        cdnBaseUrl: '/cdn',
        customCodeEndpoint: '/tdp-tenant-custom-code',
        customCodeVersion: '/latest',
        assetsLibraryEndpoint: '/tdp-assets-library',
        assetsLibraryVersion: '/latest',
        catalogsEndpoint: '/si-registry/api/v1/catalogs',
        usersEndpoint: '/tdm-users/public/current-user',
        dciAuthBaseUrl: 'https://www.dell.com',
        dciClientId: 'b0c50012-875f-4758-8a66-9580458cfabe',
        changeImpersonationUrl: 'https://techdirect.dell.com/Portal/SupportProcessor.aspx',
        tdpNavBarUrl: '/si-elements/tdp-navbar-mfe/tdp-navbar-mfe.js',
        hostUrl: 'https://tdm.dell.com'
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVudGltZS1lbnZpcm9ubWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW52aXJvbm1lbnRzL3J1bnRpbWUtZW52aXJvbm1lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQy9CLEtBQUssRUFBRTtRQUNILGdCQUFnQixFQUFFLE1BQU07UUFDeEIsbUJBQW1CLEVBQUUsRUFBRTtRQUN2QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLHFCQUFxQixFQUFFLEVBQUU7UUFDekIsbUJBQW1CLEVBQUUsRUFBRTtRQUN2QixVQUFVLEVBQUUsTUFBTTtRQUNsQixpQkFBaUIsRUFBRSxFQUFFO1FBQ3JCLHFCQUFxQixFQUFFLHFCQUFxQjtRQUM1QyxvQkFBb0IsRUFBRSxFQUFFO1FBQ3hCLGdCQUFnQixFQUFFLDhCQUE4QjtRQUNoRCxhQUFhLEVBQUUsZ0NBQWdDO1FBQy9DLGNBQWMsRUFBRSwwQkFBMEI7UUFDMUMsV0FBVyxFQUFFLHNDQUFzQztRQUNuRCxzQkFBc0IsRUFBRSwrREFBK0Q7UUFDdkYsWUFBWSxFQUFFLG1EQUFtRDtRQUNqRSxPQUFPLEVBQUUsNEJBQTRCO0tBQ3hDO0lBQ0QsT0FBTyxFQUFFO1FBQ0wsZ0JBQWdCLEVBQUUsTUFBTTtRQUN4QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLG1CQUFtQixFQUFFLEVBQUU7UUFDdkIscUJBQXFCLEVBQUUsRUFBRTtRQUN6QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLFVBQVUsRUFBRSxNQUFNO1FBQ2xCLGtCQUFrQixFQUFFLHlCQUF5QjtRQUM3QyxpQkFBaUIsRUFBRSxTQUFTO1FBQzVCLHFCQUFxQixFQUFFLHFCQUFxQjtRQUM1QyxvQkFBb0IsRUFBRSxTQUFTO1FBQy9CLGdCQUFnQixFQUFFLDhCQUE4QjtRQUNoRCxhQUFhLEVBQUUsZ0NBQWdDO1FBQy9DLGNBQWMsRUFBRSwwQkFBMEI7UUFDMUMsV0FBVyxFQUFFLHNDQUFzQztRQUNuRCxzQkFBc0IsRUFBRSw4REFBOEQ7UUFDdEYsWUFBWSxFQUFFLCtDQUErQztRQUM3RCxPQUFPLEVBQUUsaUNBQWlDO0tBQzdDO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsZ0JBQWdCLEVBQUUsTUFBTTtRQUN4QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLG1CQUFtQixFQUFFLEVBQUU7UUFDdkIscUJBQXFCLEVBQUUsRUFBRTtRQUN6QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLFVBQVUsRUFBRSxNQUFNO1FBQ2xCLGtCQUFrQixFQUFFLHlCQUF5QjtRQUM3QyxpQkFBaUIsRUFBRSxTQUFTO1FBQzVCLHFCQUFxQixFQUFFLHFCQUFxQjtRQUM1QyxvQkFBb0IsRUFBRSxTQUFTO1FBQy9CLGdCQUFnQixFQUFFLDhCQUE4QjtRQUNoRCxhQUFhLEVBQUUsZ0NBQWdDO1FBQy9DLGNBQWMsRUFBRSwwQkFBMEI7UUFDMUMsV0FBVyxFQUFFLHNDQUFzQztRQUNuRCxzQkFBc0IsRUFBRSwrREFBK0Q7UUFDdkYsWUFBWSxFQUFFLCtDQUErQztRQUM3RCxPQUFPLEVBQUUsNkJBQTZCO0tBQ3pDO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsVUFBVSxFQUFFLElBQUk7UUFDaEIsZ0JBQWdCLEVBQUUsTUFBTTtRQUN4QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLG1CQUFtQixFQUFFLEVBQUU7UUFDdkIscUJBQXFCLEVBQUUsRUFBRTtRQUN6QixtQkFBbUIsRUFBRSxFQUFFO1FBQ3ZCLFVBQVUsRUFBRSxNQUFNO1FBQ2xCLGtCQUFrQixFQUFFLHlCQUF5QjtRQUM3QyxpQkFBaUIsRUFBRSxTQUFTO1FBQzVCLHFCQUFxQixFQUFFLHFCQUFxQjtRQUM1QyxvQkFBb0IsRUFBRSxTQUFTO1FBQy9CLGdCQUFnQixFQUFFLDhCQUE4QjtRQUNoRCxhQUFhLEVBQUUsZ0NBQWdDO1FBQy9DLGNBQWMsRUFBRSxzQkFBc0I7UUFDdEMsV0FBVyxFQUFFLHNDQUFzQztRQUNuRCxzQkFBc0IsRUFBRSwwREFBMEQ7UUFDbEYsWUFBWSxFQUFFLCtDQUErQztRQUM3RCxPQUFPLEVBQUUsc0JBQXNCO0tBQ2xDO0NBQ0osQ0FBQSJ9